import React from "react";
import Header from "../components/sections/Header";
import Hero from "../components/sections/Hero";
import WhyDigital from "../components/sections/WhyDigital";
import Features from "../components/sections/Features";
import Pricing from "../components/sections/Pricing";
import HowItWorks from "../components/sections/HowItWorks";
import LeadCalendly from "../components/sections/LeadCalendly";
import CTABanner from "../components/sections/CTABanner";
import Footer from "../components/sections/Footer";
import { useReveal } from "../lib/useReveal";
import { Toaster } from "../components/ui/sonner";

export default function Landing() {
  const ref = useReveal();
  return (
    <div ref={ref} data-testid="landing-root" className="bg-brand-ivory min-h-screen">
      <Header />
      <main>
        <Hero />
        <WhyDigital />
        <Features />
        <Pricing />
        <HowItWorks />
        <LeadCalendly />
        <CTABanner />
      </main>
      <Footer />
      <Toaster position="top-right" richColors closeButton />
    </div>
  );
}
